import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Users extends AbstractController {
    protected controllerName = 'Users';
}
